var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p class=\"deleteSchemeConfirm\" style=\"margin: 15px\">"
    + container.escapeExpression(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"pos.settings.memembershipscheme.delete.confirm",(depth0 != null ? depth0.schemeName : depth0),{"name":"i18n","hash":{},"data":data}))
    + "</p>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/pos/settings/DeleteSchemeConfirm.handlebars
// module id = 625
// module chunks = 0